// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2012 Minted Inc.
 *
 * All Rights Reserved
 *
 * Flags cookie
 * https://wiki.minted.com/index.php/Flags_Cookie
 */

M.Flag = M.Flag || {};

// NOTE: The authoritative list of flags is in
// drupal/minted_api/utility/cookie/FlagsCookie.class.php and
// src/py/minted/web/flags.py -- the only flags which are included
// here are the ones which need to be set from javascript directly.
// To allocate a new flag, do not add it here first, instead first add
// it to drupal/minted_api/utility/cookie/FlagsCookie.class.php and
// src/py/minted/web/flags.py

// https://wiki.minted.com/index.php/Pin_Boards_1.0#First-run_Help_Bubble
M.Flag.PINBOARD_FIRST_RUN_HELP_BUBBLE_ALREADY_SHOWN = 0;

// https://wiki.minted.com/index.php/Print_Shopping#Print_Product_Detail_Page
M.Flag.ART_PDP_FIRST_RUN_PINBOARD_BUBBLE_SHOWN = 1;

// https://wiki.minted.com/index.php/Designer_Shop_and_Studio_Summer_2012
// https://bugs.minted.com/show_bug.cgi?id=9679
M.Flag.STOREFRONT_MANAGE_SELECT_CATEGORY_BUBBLE_SHOWN = 2;
M.Flag.STOREFRONT_MANAGE_DRAG_DROP_BUBBLE_SHOWN = 3;
M.Flag.STOREFRONT_MANAGE_FEATURED_ITEMS_BUBBLE_SHOWN = 4;
M.Flag.STOREFRONT_MANAGE_MULTIPLE_ITEMS_BUBBLE_SHOWN = 5;

// https://wiki.minted.com/index.php/User_acquisition_lightbox
M.Flag.EMAIL_DIALOG_SIGNED_UP = 6;

// https://wiki.minted.com/index.php/Holiday_2012_Category_Page_Banners
M.Flag.HOLIDAY_2012_NEW_VISITOR_BANNER_CLOSED = 7;
M.Flag.HOLIDAY_2012_BANNER_CLOSED = 8;
M.Flag.GENERIC_SAMPLE_KIT_CLOSED = 9;

M.Flag.SEEN_PARTY_UPSELL = 10;

M.Flag.CU3_LETTERPRESS_SEEN_INK_COLOR_TOOLTIP = 11;

M.Flag.TOGGLE_DESKTOP_SITE = 12;

M.Flag.CLOSED_HOMEPAGE_PUSH_DOWN = 13;

M.Flag.SEEN_FANCY_RCP_TOOLTIP = 14;

/**
 * Given an original cookie value, return the new cookie value with
 * the flag at $offset set to $boolean
 */
M.Flag.setFlagInCookie = function(origCookie, offset, isSet) {
  var f = origCookie;
  // Restore padding
  while (((f.length % 4) >>> 0) != 0) {
    f = f + '=';
  }
  f = f.replace(/-/g, '+').replace(/_/g, '/');
  f = Webtoolkit.Base64.decode(f, true);

  // Since javascript has no integers, >>> 0 forces to unsigned int32
  var offsetByte = (offset / 8) >>> 0;
  var offsetBit = (offset % 8) >>> 0;
  var offsetMask = (1 << ((7 - offsetBit) >>> 0)) >>> 0;

  if (offsetByte >= f.length) {
    // If the cookie is too short, increase it to the right size
    f = f + Array(offsetByte - f.length + 2).join(String.fromCharCode(0));
    if (offsetByte + 1 != f.length) {
      throw 'Assertion failure';
    }
  }
  if (offsetByte >= f.length) {
    throw 'Assertion failure';
  }

  if (isSet) {
    f = f.substring(0, offsetByte) +
      String.fromCharCode(f.charCodeAt(offsetByte) | offsetMask) +
      f.substring(offsetByte + 1);
  } else {
    f = f.substring(0, offsetByte) +
      String.fromCharCode(f.charCodeAt(offsetByte) & ~offsetMask) +
      f.substring(offsetByte + 1);
  }

  // Shorten if possible
  f = f.replace(/\000*$/, '');
  // But always have at least one byte
  if (f.length == 0) {
    f = String.fromCharCode(0);
  }
  // Encode
  f = Webtoolkit.Base64.encode(f, true);
  // Remove = padding
  f = f.replace(/=*$/, '');
  // Make URL safe
  f = f.replace(/\+/g, '-').replace(/\//g, '_');
  return f;
};

M.Flag.getFlagInCookie = function(origCookie, offset) {
  var f = origCookie;
  // Restore padding
  while (((f.length % 4) >>> 0) != 0) {
    f = f + '=';
  }
  f = f.replace(/-/g, '+').replace(/_/g, '/');
  f = Webtoolkit.Base64.decode(f, true);

  // Since javascript has no integers, >>> 0 forces to unsigned int32
  var offsetByte = (offset / 8) >>> 0;
  var offsetBit = (offset % 8) >>> 0;
  var offsetMask = (1 << ((7 - offsetBit) >>> 0)) >>> 0;

  if (offsetByte >= f.length) {
    return false;
  }

  return ((f.charCodeAt(offsetByte) & offsetMask) != 0);
};

M.Flag.setFlag = function(offset, isSet) {
  var f = '',
      cookie = $.cookie('f');
  if (cookie) {
    f = cookie;
  }

  $.cookie('f', M.Flag.setFlagInCookie(f, offset, isSet), {
    expires: 365 * 10,
    path: '/'
  });
};

M.Flag.getFlag = function(offset) {
  var f = '',
      cookie = $.cookie('f');
  if (cookie) {
    f = cookie;
  }

  return M.Flag.getFlagInCookie(f, offset);
};
